// 公用
export const commonConstant = {
  TOKEN_NAME: 'Authorization',
  LOGIN_USER_KEY: 'loginUser',
  USER_ACCOUNT_KEY: 'userAccount',
  PASSWORD_KEY: 'password',
  REMENBER_ME_KEY:'rememberMe',
  HONG_KONG_HOST: 'https://hg.tttld.com',
  LANGUAGE_VERSION_ZH_CN: '1.0.4', // 中文语言版本,用于激活更新
  LANGUAGE_VERSION_EN: '1.0.3' // 英文版本
};

// 设备机型
export const deviceModelConstant = {
  MANAGEMENT: 'management',
  VOICE_GATEWAY: 'voiceGateway',
  EXTENSION:'extension',
  VOICE_EXTENSION:'voiceExtension',
};

// 消息队列日志
export const messageLogConstant = {
  URL: '/home/messagelog',
  SEARCH: 'message-log-search'
};

// 上电记录
export const upRecordConstant = {
  URL: '/home/upRecord',
  SEARCH: 'up-record-search'
};

// 设备
export const deivceConstant = {
  URL: '/home/deviceList',
  SN_SEARCH_HISTROY: 'snSearchHistory',
  ICCID_SEARCH_HISTROY: 'iccidSearchHistory',
  VER_SEARCH_HISTROY: 'verSearchHistory',
  SEAT_SEARCH_HISTROY: 'seatSearchHistory',
  SEARCH: 'device-list-search',
  RESET:'device-list-reset',
  BATCH_RESET:'device-list-batch-reset',
  REFRESH_SETTING:'device-list-refresh-setting',
  BIND_CUSTOMER:'device-list-bind-customer',
  UNBIND_CUSTOMER:'device-list-unbind-customer',
  BATCH_BIND_CUSTOMER:'device-list-batch-bind-customer',
  BATCH_UNBIND_CUSTOMER:'device-list-batch-unbind-customer',
  BIND_RECORD:'device-list-bind-record',
  LOG:'device-list-log',
  SSH:'device-list-ssh',
  UPDATE_SETTING:'device-list-update-setting',
  OPEN_ICCID:'device-list-open-iccid',
  WHITE_LIST:'device-list-white-list',
  PUSH_FACTORY_ADDRESS:'device-list-push-factory-address',
  SW_MOD_LIST:['黑通力白通力 TF-2 东芝 DZFZ-X','新日立','DAA','新国标通力','广日的 NET24_AC','广日的 GRT_AN'],
  SVER_LIST:['LuDiDtmfMux','LuDiKone','LuDixunda','LuDiXHB_9901'],
};

// 1代平台数据
export const onePlatformDataConstant = {
  URL: '/home/firstPlatformData',
  SEARCH: 'first-platform-data-search',
};

// 项目管理
export const projectListConstant = {
  URL: '/home/projectList',
  SEARCH: 'project-list-search',
  DEVICE_SEARCH:'project-list-device-search',
  UDPATE_ADDRESS_SETTING:'project-list-udpate-address-setting',
  EXTENSION_SYNCHRONOUS:'project-list-extension-synchronous',
  UDPATE_EXTENSION_CALL:'project-list-udpate-extension-call',
  ADDRESS_TREE:'project-list-address-Tree',
  PUSH_ADDRESS:'project-list-push-address',
  ASSOCIATED_EXTENSION_CALL:'project-list-associated-extension-call',
  UPLOAD_EXTENSION_ADDRESS:'project-list-upload-extension-address',
  UPLOAD_ADDRESS_BIND_DEVICE:'project-list-upload-address-bind-device',
  UPLOAD_ADDRESS_TO_UPDATE:'project-list-upload-address-to-update',
  BIND_SETTING:'project-list-bind-setting',
};

// 客户管理
export const customersConstant = {
  URL: '/home/customers',
  NICKNAME_SEARCH_HISTROY: 'nickNameSearchHistory',
  USERACCOUNT_SEARCH_HISTROY: 'userAccountSearchHistory',
  SEARCH: 'customers-search',
  ADD:'customers-add',
  UPDATE:'customers-update',
  DELETE:'customers-delete',
  RESET_PASSWORD:'customers-reset-password',
  CHANGE:'customers-change',
  BIND:'customers-bind',
  UNBIND:'customers-unbind',
  CHANGE_STATUS:'customers-change-status',
  ELEVATOR_SETTING:'customers-elevator-setting',
};

// 通话记录
export const callRecordConstant = {
  URL: '/home/callRecord',
  SEARCH: 'call-record-search',
  PLAY: 'call-record-play',
};

// 升级信息
export const deviceLevelUpConstant = {
  URL: '/home/deviceLevelUp',
  LEVELUP_CREATE_TIME_SEARCH_HISTROY: 'levelUpCreateTimeSearchHistory',
  LEVELUP_PLAN_NAME_SEARCH_HISTROY: 'levelUpPlanNameSearchHistory',
  SEARCH: 'device-level-up-search',
  ADD_PLAN:'device-level-up-add-plan',
  CLEAR:'device-level-up-clear',
  ADD_DEVICE:'device-level-up-add-device',
};

// 升级文件管理
export const levelUpFileMgtConstant = {
  URL: '/home/deviceLevelUp',
  UP_FILENAME_SEARCH_HISTROY: 'upFileNameSearchHistory',
  SEARCH: 'device-level-up-file-search',
  UPLOAD:'device-level-up-file-upload',
  DELETE:'device-level-up-file-delete',
  BATCH_DELETE:'device-level-up-file-batch-delete',
  DOWNLOAD:'device-level-up-file-download',
};

// 物联网卡接口日志
export const iotLogConstant = {
  URL: '/home/iotLog',
  IOT_LOG_REQUEST_API_SEARCH_HISTROY: 'iotLogRequestaApiSearchHistory',
  IOT_LOG_REQUEST_PARAMETERS_SEARCH_HISTROY: 'iotLogRequestaParametersSearchHistory',
  IOT_LOG_RETURNS_SEARCH_HISTROY: 'iotLogReturnsSearchHistory',
  SEARCH: 'iot-log-search',
  DELETE:'iot-log-delete',
  MSISDN_SEARCH_HISTROY: 'msisdnSearchHistory'
};

// 物联网卡齐犇
export const voiceIotTibiotConstant = {
  URL: '/home/voiceIotTibiot',
  SEARCH: 'voice-iot-tibiot-search',
  WHITE_ADD:'voice-iot-tibiot-white-add',
  WHITE_SEARCH:'voice-iot-tibiot-white-search',
  DELETE_WHITE:'voice-iot-tibiot-delete-white',
  SYNCHRONIZE_DEVICE:'voice-iot-tibiot-synchronize-device',
};

// 物联网卡旭宇
export const flowIotShingsouConstant = {
  URL: '/home/flowIotShingsou',
  SEARCH: 'flow-iot-shingsou-search',
  ENABLE:'flow-iot-shingsou-enable',
  FLOW:'flow-iot-shingsou-flow',
};

// 项目组
export const projectGroupConstant = {
  URL: '/home/projectGroup',
  SEARCH: 'project-group-search',
  SEARCH_DEVICE:'project-group-search-device',
  ADD:'project-group-add',
  DELETE:'project-group-delete',
  ADD_PROJECT:'project-group-add-project',
  REMOVE_PROJECT:'project-group-remove-project',
  ADD_MAINS:'project-group-add-mains',
  REMOVE_MAINS:'project-group-remove-mains',
  COPY_PROJECT_DATA:'project-group-copy-project-data',
};

// 物联网卡换卡记录
export const iotReplaceRecordConstant = {
  URL: '/home/iotReplace',
  SEARCH: 'iot-replace-search',
};

// 角色权限
export const roleConstant = {
  URL: '/home/role',
  SEARCH: 'system-role-search',
  ASSIGN:'system-role-assign',
};

// 系统操作日志
export const operationLogConstant = {
  URL: '/home/operationLog',
  SEARCH: 'system-operation-log-search',
  DELETE:'system-operation-log-delete',
};

// 在线用户
export const onlineUsersConstant = {
  URL: '/home/onlineUsers',
  SEARCH: 'system-online-users-search',
  KICK:'system-online-users-kick',
};

// 大屏数据可视化
export const bigScreenDataViewConstant = {
  URL: '/home/bigScreenDataView',
  ELEVATOR_DATA_URL: '/home/elevatorDataBigScreen',
};

// 文件管理
export const sysFileConstant = {
  URL: '/home/sysFile',
  SEARCH: 'system-file-mgt-search',
  UPLOAD:'system-file-mgt-upload',
  DELETE:'system-file-mgt-delete',
  MODULE_UPLOAD_SOOTHING_VOICE_ID:216,
  MODULE_DEVICE_NAMEPLATE_IMAGE_ID:222,
  MODULE_DEVICE_MANUAL_ID:235,
};

// 充值价格
export const deviceRechargeInfoConstant = {
  URL: '/home/deviceRechargeInfo',
  SEARCH: 'system-file-mgt-search',
  ADD:'recharge-price-add',
  UPDATE:'recharge-price-update',
  DELETE:'recharge-price-delete',
};

// 充值价格规则
export const deviceRechargeRulesConstant = {
  URL: '/home/deviceRechargeRules',
  SEARCH: 'system-file-mgt-search',
  ADD:'recharge-price-add',
  UPDATE:'recharge-price-update',
  DELETE:'recharge-price-delete',
};

// 设备手册
export const deviceManualConstant = {
  URL: '/home/deviceManual',
  SEARCH: 'device-manual-search',
  ADD:'device-manual-add',
  UPDATE:'device-manual-update',
  DELETE:'device-manual-delete',
  ENABLE:'device-manual-enable',
};

// 设备手册
export const deviceLifeCycleConstant = {
  URL: '/home/deviceLifeCycle',
  SEARCH: 'device-life-cycle-search',
  ADD:'device-life-cycle-add',
  UPDATE:'device-life-cycle-update',
  DELETE:'device-life-cycle-delete',
  ENABLE:'device-life-cycle-enable',
};


// WEBPACK FOOTER //
// ./src/utils/Constants.js